module.exports = __webpack_public_path__ + "static/media/5031.18fc8f61.jpg";